import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { isCardAdminChannelPayForm, PAYMENT_METHODS } from '../lists/payment-methods';

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'paymentMethod'
})
export class PaymentMethodPipe implements PipeTransform {
  paymentKeys = Object.keys(PAYMENT_METHODS);

  transform(value: string): string {
    if (isCardAdminChannelPayForm(value)) {
      return value;
    }

    if(PAYMENT_METHODS[value]){
      return PAYMENT_METHODS[value];
    }

    for (const key of this.paymentKeys) {
      if(PAYMENT_METHODS[key] === value){
        return key;
      }
    }

    if (["03-tef", "04-tef"].includes(value)) {
      return value;
    }

    return '99';
  }
}
